import { render, staticRenderFns } from "./ModalCustomerPurchaseOrders.vue?vue&type=template&id=4515692c&scoped=true&lang=pug&"
import script from "./ModalCustomerPurchaseOrders.vue?vue&type=script&lang=js&"
export * from "./ModalCustomerPurchaseOrders.vue?vue&type=script&lang=js&"
import style0 from "./ModalCustomerPurchaseOrders.vue?vue&type=style&index=0&id=4515692c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4515692c",
  null
  
)

export default component.exports